if (!customElements.get('campanha-countdown')) {
  customElements.define('campanha-countdown', class extends HTMLElement {
    connectedCallback() {
      this.end = Date.parse(this.dataset.endDate);
      if (!this.end) return;
      this.parts = {};
      this.querySelectorAll('[data-part]').forEach((el) => (this.parts[el.dataset.part] = el));
      this.ac = new AbortController();
      document.addEventListener('visibilitychange', () => this.sync(), { signal: this.ac.signal });
      this.io = new IntersectionObserver((e) => {
        this.seen = e[0].isIntersecting;
        this.sync();
      });
      this.io.observe(this);
      this.tick();
    }
    sync() {
      if (this.seen && !document.hidden && !this.hidden) {
        if (!this.timer) {
          this.tick();
          this.timer = setInterval(() => this.tick(), 1000);
        }
      } else this.stop();
    }
    stop() {
      clearInterval(this.timer);
      this.timer = null;
    }
    put(k, v) {
      const el = this.parts[k];
      if (el && el.textContent !== v) el.textContent = v;
    }
    tick() {
      const left = this.end - Date.now();
      if (left < 0) {
        this.hidden = true;
        return this.stop();
      }
      const t = Math.floor(left / 1000);
      const d = Math.floor(t / 86400);
      const p = (n) => String(n).padStart(2, '0');
      if (this.parts.d) this.parts.d.hidden = d === 0;
      this.put('d', d + 'd');
      this.put('h', p(Math.floor(t / 3600) % 24) + 'h');
      this.put('m', p(Math.floor(t / 60) % 60) + 'm');
      this.put('s', p(t % 60) + 's');
    }
    disconnectedCallback() {
      this.stop();
      this.io.disconnect();
      this.ac.abort();
    }
  });
}
